<template>
  <div class="register-wrapper d-flex justify-content-center align-items-center min-vh-100">
    <div class="card shadow-lg rounded-4 bg-white bg-opacity-75" style="width: 100%; max-width: 500px;">
      <div class="card-body p-4">
        <h2 class="text-center mb-4">De Park Register Form</h2>

        <!-- ✅ Pesan muncul di atas form -->
        <div v-if="successMessage" class="alert alert-success text-center mb-3" v-html="successMessage"></div>
        <div v-if="errorMessage" class="alert alert-danger text-center mb-3" v-html="errorMessage"></div>

        <form @submit.prevent="submitForm" novalidate>
          <div class="mb-3">
            <label for="nama" class="form-label">Nama Lengkap</label>
            <input
              v-model="form.nama"
              @input="form.nama = form.nama.toUpperCase()"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': errors.nama }"
              id="nama"
            />
            <div class="invalid-feedback">{{ errors.nama }}</div>
          </div>

          <div class="mb-3">
            <label for="email" class="form-label">Email address</label>
            <input
              v-model="form.email"
              @input="form.email = form.email.toLowerCase()"
              type="email"
              class="form-control"
              :class="{ 'is-invalid': errors.email }"
              id="email"
            />
            <div class="invalid-feedback">{{ errors.email }}</div>
          </div>

          <div class="mb-3">
            <label for="password" class="form-label">Password</label>
            <div class="input-group">
              <input
                v-model="form.password"
                :type="showPassword ? 'text' : 'password'"
                class="form-control"
                :class="{ 'is-invalid': errors.password }"
                id="password"
              />
              <button type="button" class="btn btn-outline-secondary" @click="togglePassword">
                <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
              </button>
              <div class="invalid-feedback">{{ errors.password }}</div>
            </div>
          </div>

          <button type="submit" class="btn btn-success w-100">Register</button>

          <div class="text-center mt-4">
            <router-link to="/" class="text-primary text-decoration-underline">
              Sign In
            </router-link>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>


<script setup>
import { reactive, ref } from 'vue'
import axios from 'axios'

const form = reactive({
  nama: '',
  email: '',
  password: ''
})

const errors = reactive({})
const successMessage = ref('')
const errorMessage = ref('')
const showPassword = ref(false)

const togglePassword = () => {
  showPassword.value = !showPassword.value
}

const validateForm = () => {
  errors.email = !form.email
    ? 'Email is required'
    : !/\S+@\S+\.\S+/.test(form.email)
    ? 'Email is invalid'
    : ''

  errors.nama = !form.nama ? 'Nama is required' : ''
  errors.password = !form.password ? 'Password is required' : ''

  return !errors.email && !errors.nama && !errors.password
}

const submitForm = async () => {
  if (!validateForm()) return

  try {
    await axios.post('https://metatekapps.metateknologi.com/api-vms-register.php', {
      nama: form.nama,
      email: form.email,
      password: form.password
    })

    successMessage.value = '🎉 Registrasi berhasil!<br>Silahkan cek link aktivasi di email anda'
    errorMessage.value = ''
    form.nama = ''
    form.email = ''
    form.password = ''
  } catch (error) {
    successMessage.value = ''
    errorMessage.value = error.response?.data?.message || 'Registrasi Gagal.<br>User sudah terdaftar.'
  }
}
</script>


<style scoped>
.register-wrapper {
  background: url('https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=1350&q=80') no-repeat center center;
  background-size: cover;
}

.card {
  backdrop-filter: blur(10px);
}
</style>
